// extracted by css-extract-rspack-plugin
export default {"list":"list-wS1epk","saved":"saved-otEUrF"};